import { useNavigate } from 'react-router-dom';
import { useGlobalContext } from '../context/GlobalContext';
import Loading from '../components/Loading';
import { useEffect } from 'react';

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const { user, userLoading } = useGlobalContext();

  console.log('ProtectedRoute entered');
  console.log(userLoading);
  console.log(user);

  useEffect(() => {
    if (userLoading) return <Loading />;

    if (!user && !user.isAdmin) {
      return navigate('/home');
    }

    if (!user.isAdmin) {
      console.log('!user.isAdmin entered');
      return navigate('/auth/profile');
    }
  }, [user, navigate]);

  return children;
};
export default ProtectedRoute;
